/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is percentage decrease the same as percentage change?`)
};

const es_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es la disminución porcentual lo mismo que el cambio porcentual?`)
};

const de_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist der prozentuale Rückgang dasselbe wie die prozentuale Veränderung?`)
};

const nl_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is percentagedaling hetzelfde als percentageverandering?`)
};

const fr_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La diminution en pourcentage est-elle la même chose que la variation en pourcentage ?`)
};

const it_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il calo percentuale è la stessa cosa della variazione percentuale?`)
};

const pt_br2_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A diminuição percentual é o mesmo que a variação percentual?`)
};

const pt_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A diminuição percentual é o mesmo que a variação percentual?`)
};

const ja_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント減少とパーセント変化は同じですか？`)
};

const zh_pct_decrease_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比减少和百分比变化是一回事吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_faq2_q", locale)
	if (locale === "en") return en_pct_decrease_faq2_q(inputs)
	if (locale === "es") return es_pct_decrease_faq2_q(inputs)
	if (locale === "de") return de_pct_decrease_faq2_q(inputs)
	if (locale === "nl") return nl_pct_decrease_faq2_q(inputs)
	if (locale === "fr") return fr_pct_decrease_faq2_q(inputs)
	if (locale === "it") return it_pct_decrease_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_faq2_q(inputs)
	if (locale === "pt") return pt_pct_decrease_faq2_q(inputs)
	if (locale === "ja") return ja_pct_decrease_faq2_q(inputs)
	return zh_pct_decrease_faq2_q(inputs)
};